import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-206ce5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-description" }
const _hoisted_6 = { class: "person-info-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "person-image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/car-detail/man.png",
    alt: "Person Image"
  })
], -1))
const _hoisted_8 = { class: "person-details" }
const _hoisted_9 = { class: "detail-name" }
const _hoisted_10 = { class: "detail1" }
const _hoisted_11 = { class: "detail" }
const _hoisted_12 = { class: "detail" }
const _hoisted_13 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: "/img/close-btn.svg",
            class: "close-popup-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeConfirmPopup && _ctx.closeConfirmPopup(...args)))
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.title" })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_i18n_t, {
                keypath: "dashboard.confirmDate.description",
                date: _ctx.localFormatDate,
                count: _ctx.vehiclesId?.length ?? '#'
              }, null, 8, ["date", "count"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(`${_ctx.order?.account_manager?.firstname} ${_ctx.order?.account_manager?.lastname}`), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.accountManager.email" }),
                _createTextVNode(" : " + _toDisplayString(_ctx.order?.account_manager?.email ?? "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.accountManager.phone" }),
                _createTextVNode(" : " + _toDisplayString(_ctx.order?.account_manager?.phone ?? "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.accountManager.parkingHours" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "button-text cancel-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeConfirmPopup && _ctx.closeConfirmPopup(...args)))
              }, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.cancelButton" })
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "button-text decline-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmHandle && _ctx.confirmHandle(...args)))
              }, [
                _createVNode(_component_i18n_t, { keypath: "dashboard.confirmDate.confirmButton" })
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}